"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var SendMoneyIconNoBackground = function SendMoneyIconNoBackground(props) {
  return _react["default"].createElement("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("title", null, "Money Transfer Rates"), _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("polygon", {
    fill: props.colour || "#FFFFFF",
    transform: "translate(20.829734, 11.829734) rotate(-45.000000) translate(-20.829734, -11.829734) ",
    points: "5.95387213 -1.21374461 5.82973365 9.08952322 27.110418 11.9592848 5.82973365 14.8290464 5.84392077 24.8732119 35.8297336 11.4713869"
  })));
};

var _default = SendMoneyIconNoBackground;
exports["default"] = _default;